import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { loopBreak } from "../../Runtime/RuntimeExecution";
import { DataType } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { variableInPropertyName, variablesPropertyLabel } from "../../UserDefinedSchemaManagement/LoopVariableEditor";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.forEachBreak,
  category: NodeTypeCategory.lists,
  innerLoop: true,
  label: "Loop Exit",
  controlInputOnly: true,
  controlInputs: [{ name: "break" }],
  controlOutputs: [],
  dataInputs: [{ name: variableInPropertyName, label: variablesPropertyLabel, type: DataType.OBJECT, required: false, enabled: false }],
  dataOutputs: [],
  size: NodeSize.Small,
  nodeConfigProperties: [
    {
      name: "loopVariableSchema",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: { sourceSystem: DocumentSchemaSource.userDefined, dataParams: [variableInPropertyName] }
    }
  ],
  evaluate: () => {
    loopBreak();
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const ForEachBreakNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
